import { Platform } from 'react-native';

export const isPricingPage = () => {
  // TODO: not working anymore
  return Platform.OS === 'web'
    ? document.location.pathname.includes('Pricing') ||
        document.location.pathname.includes('/m/')
    : true;
};
